@if (showVideo()) {
  <div class="video-player-container hmf-mt-s hmf-display-flex hmf-align-items-stretch hmf-flex-direction-row hmf-w-100">
    <div id="criteo-video-player" class="criteo-video-player hmf-img-ratio-16x9"></div>
    <div class="criteo-video-products hmf-overflow-hidden hmf-position-relative">
      <hmf-pagination-carousel
        role="button"
        tabindex="0"
        [arrowCentered]="true"
        [autoPlay]="false"
        [itemsPerView]="1"
        [scrollable]="false"
        [showHeader]="false"
        [showSubtitle]="false"
        [showTitle]="false"
        (pageChanged)="onPageChanged($event)"
        (click)="onCarouselClick($event)"
        (keydown.enter)="onCarouselClick($event)"
        (keydown.space)="onCarouselClick($event); $event.preventDefault()">
        @for (product of products(); track product.productId; let i = $index) {
          <div
            class="criteo-video-{{product.productId}} criteo-video-product-slide hmf-display-flex hmf-flex-column hmf-justify-content-center">
            <shared-components-criteo-video-product-card
              class="hmf-flex-column"
              [product]="product"
              [attr.data-em]="criteoDataEms()[i] ?? ''"
              (addToCartClicked)="onAddToCartClicked(product)">
            </shared-components-criteo-video-product-card>
          </div>
        }
      </hmf-pagination-carousel>
    </div>
  </div>
  <div class="sponsored hmf-legal-s hmf-pt-xxxs hmf-text-align-right hmf-w-100">
    Sponsored
  </div>
}
